/* eslint-disable no-shadow */
const state = {
	agentAuthenticated: false
}

const getters = {
	isAgentAuthenticated: state => state.agentAuthenticated
}

const mutations = {
	setAgentAuthenticatedMutation: (state, payload) => {
		state.agentAuthenticated = payload
	}
}

const actions = {
	setAgentAuthenticated: ({ commit }, payload) => {
		commit('setAgentAuthenticatedMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
